import { Pin } from 'lucide-react';

const idsMatch = (a, b) => String(a || '') === String(b || '');

const ConversationPinMenuItems = ({
	auth,
	conversation,
	displayNotification,
	ItemComponent,
	toggleConversationPin,
}) => {
	const currentUserId = auth.user?._id;
	const isPinnedForMe = (conversation?._pinnedByUsers || []).some((_user) =>
		idsMatch(_user, currentUserId),
	);
	const isPinnedForBusiness = !!conversation?.pinnedForBusiness;

	const handleToggleConversationPin = async ({ scope, pinned }) => {
		const res = await toggleConversationPin({
			conversation,
			scope,
			pinned,
		});

		if (res?.error) {
			displayNotification({
				message: res.message || 'Error updating conversation pin',
				error: true,
			});
		}
	};

	return (
		<>
			<ItemComponent
				className="gap-2"
				onSelect={() =>
					handleToggleConversationPin({
						scope: 'user',
						pinned: !isPinnedForMe,
					})
				}
			>
				<Pin className="size-4" />
				{isPinnedForMe ? 'Unpin for me' : 'Pin for me'}
			</ItemComponent>
			<ItemComponent
				className="gap-2"
				onSelect={() =>
					handleToggleConversationPin({
						scope: 'business',
						pinned: !isPinnedForBusiness,
					})
				}
			>
				<Pin className="size-4" />
				{isPinnedForBusiness ? 'Unpin for everyone' : 'Pin for everyone'}
			</ItemComponent>
		</>
	);
};

export default ConversationPinMenuItems;
